module.exports = __webpack_public_path__ + "static/media/Melissa_Diaz.fa625f7d.png";